export default __webpack_public_path__ + "static/media/course-language.51878ac6.svg";